<script>
import entry from '../../entry';
import _0 from './_0.vue';
import _1 from './_1.vue';
import _2 from './_2.vue';
import _3 from './_3.vue';
import _4 from './_4.vue';
import _6 from './_6.vue';
import _7 from './_7.vue';

const components = { _0, _1, _2, _3, _4, _6, _7 };
const map = {
  0: '_0',
  1: '_1',
  2: '_2',
  3: '_3',
  4: '_4',
  6: '_6',
  7: '_7'
};

export default entry({
  name: 'coupon-template-detail-entry',
  components,
  map
});
</script>
